// extracted by mini-css-extract-plugin
module.exports = {"container":"DefaultLevel_container__j9lbr","blockName":"DefaultLevel_blockName__3E79j"};